<div class="auth-shell" *transloco="let t">
  <section class="auth-shell__visual">
    <div class="auth-shell__visual-overlay"></div>
    <div class="auth-shell__spark auth-shell__spark--one"></div>
    <div class="auth-shell__spark auth-shell__spark--two"></div>

    <div class="auth-shell__brand">
      <h1 class="auth-shell__title">{{ t('auth_layout.hero_title') }}</h1>
      <p class="auth-shell__subtitle">{{ t('auth_layout.hero_subtitle') }}</p>

      <ul class="auth-shell__feature-list">
        <li>
          <span class="auth-shell__feature-icon">
            <i class="fas fa-check"></i>
          </span>
          <span>{{ t('auth_layout.feature_versions') }}</span>
        </li>
        <li>
          <span class="auth-shell__feature-icon">
            <i class="fas fa-check"></i>
          </span>
          <span>{{ t('auth_layout.feature_notes') }}</span>
        </li>
        <li>
          <span class="auth-shell__feature-icon">
            <i class="fas fa-check"></i>
          </span>
          <span>{{ t('auth_layout.feature_compare') }}</span>
        </li>
      </ul>
    </div>
  </section>

  <main class="auth-shell__content" id="mainContent">
    <div class="auth-shell__content-inner">
      <div class="auth-shell__panel">
        <ng-content></ng-content>
      </div>
    </div>
  </main>
</div>
